<template>
  <div class="ctx-banner" :class="isDark ? 'ctx-banner--dark' : 'ctx-banner--light'">
    <!-- Header row: avatar + info + clear button -->
    <div class="ctx-banner__header">
      <div class="ctx-avatar">{{ clientInitials }}</div>
      <div class="ctx-info">
        <span class="ctx-name">{{ clientDisplayName }}</span>
        <span class="ctx-rut">{{ selectedClient.rut }}</span>
      </div>
      <button class="ctx-clear" @click="clearClient" title="Salir del contexto de cliente (Esc Esc)">
        <i class="mdi mdi-close" />
      </button>
    </div>

    <!-- Quick links row -->
    <div class="ctx-links">
      <button
        v-for="link in quickLinks"
        :key="link.label"
        class="ctx-link"
        :title="link.label"
        @click="navigate(link.to)"
      >
        <i :class="'mdi ' + link.icon" />
        <span>{{ link.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ClientContextBanner',

  computed: {
    ...mapGetters('clientContext', ['selectedClient', 'clientDisplayName', 'clientInitials']),
    ...mapGetters('app', ['globalTheme']),

    isDark() {
      return this.$store.state.app.globalTheme;
    },

    quickLinks() {
      return [
        { label: 'Servicios',       icon: 'mdi-check-circle-outline',       to: '/apps/servicios/padres' },
        { label: 'Notas de cobro',  icon: 'mdi-note-text-outline',           to: '/notas-cobros' },
        { label: 'Tickets',         icon: 'mdi-ticket-confirmation-outline', to: '/apps/board' },
        { label: 'Dashboard',       icon: 'mdi-dns',                         to: '/dashboardClient_search' },
        { label: 'Resumen',         icon: 'mdi-account-details-outline',     to: '/resumen-cliente' },
      ];
    },
  },

  methods: {
    ...mapActions('clientContext', ['clearClient']),

    navigate(path) {
      this.$router.push(path).catch(() => {});
    },
  },
};
</script>

<style scoped>
.ctx-banner {
  margin: 8px 8px 0;
  border-radius: 10px;
  border-left: 3px solid #0fa3a3;
  overflow: hidden;
}

.ctx-banner--light {
  background: rgba(15, 163, 163, 0.08);
}

.ctx-banner--dark {
  background: rgba(15, 163, 163, 0.13);
}

.ctx-banner__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 6px;
}

.ctx-avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #0fa3a3;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.5px;
}

.ctx-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.ctx-name {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #0fa3a3;
  line-height: 1.3;
}

.ctx-rut {
  font-size: 10px;
  opacity: 0.7;
  line-height: 1.3;
}

.ctx-clear {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  transition: opacity 0.15s, background 0.15s;
  color: inherit;
}

.ctx-clear:hover {
  opacity: 1;
  background: rgba(15, 163, 163, 0.2);
}

.ctx-clear .mdi {
  font-size: 14px;
}

.ctx-links {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 0 8px 8px;
}

.ctx-link {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 7px;
  border-radius: 6px;
  border: 1px solid rgba(15, 163, 163, 0.3);
  background: transparent;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  color: #0fa3a3;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.ctx-link:hover {
  background: rgba(15, 163, 163, 0.15);
  border-color: rgba(15, 163, 163, 0.6);
}

.ctx-link .mdi {
  font-size: 12px;
}
</style>
